import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/functions';
import 'firebase/compat/storage';
import { getFirebaseConfig } from './getFirebaseConfig';

firebase.initializeApp(getFirebaseConfig());

export const functions = firebase.app().functions('europe-west3');
export const firestore = firebase.firestore();
export const auth = firebase.auth();
export const storage = firebase.storage();

// Local emulator?
if (process.env.REACT_APP_EMULATOR === 'true') {
  const HOST = "localhost";
  // const HOST = "192.168.43.178";
  functions.useEmulator(HOST, 5001);
  firestore.useEmulator(HOST, 8080);
  auth.useEmulator(`http://${HOST}:9099`);
  storage.useEmulator(HOST, 9199);
}

export default firebase;